import Image from "next/image"

import { PageHeader } from '../fuselage/layout/charity/page-header/page-header'
import { Button } from "../fuselage/components/button/button"
import { ScrollTicker } from "../fuselage/blocks/scroll-ticker/scroll-ticker"

import CSS from '../css/app/charity.module.css'

export default function Charity
 () {
    return (
        <>
            <PageHeader />

            <section className={CSS.layout}>
                <div className={`${CSS.layoutHero} grid-offset-negative`}>
                    <p className={`${CSS.container} bg-primary fs-1 fw-400 caps lh-1`}>What is Cesta za&nbsp;snem?</p>
                    <div className={CSS.imageWrapper} style={{ aspectRatio: `840/588`}}>
                        <Image src={`/assets/img/charity/what-is.jpg`} layout={`fill`}  alt="" />
                    </div>
                </div>

                <div className={`${CSS.container} bg-accent p-lg formatted`}>
                    <p className="fs-5">Cesta za snem (Journey to a Dream) is a non-profit organization connecting the world of disabled and able-bodied people through sports.</p>
                    <p>It creates projects where people spend time together actively. Its goal is to create an environment where everyone can share their dreams, challenges, and passions and everyone can join. Integration and the ability of the disabled to lead a normal life is also proven by the organization itself by the fact that all its employees have a handicap. The biggest project of Cesta za snem is the Metrostav handy cycle marathon, in which cycling teams with at least one disabled member travel around the Czech Republic on a route 2222 km long, all within a time limit of 111 hours. This unique project even received the European Commission&apos;s EU Sport Awards #BeInclusive in the Celebrating Diversity category last year.</p>
                    <p>Each year, Cesta za snem organizes dozens of sports events in which everyone can participate. Its aim is to motivate not only people with disabilities to sport and exercise, which are the basis of a healthy lifestyle leading to a self-sufficient and quality life.</p>

                    <p className='fw-600 mt-md'><Button href="https://www.cestazasnem.cz/index.html" target={`_blank`} inverse>More info</Button></p>
                </div>
            </section>


            {/* donate */}

            <div className="py-md">
                <ScrollTicker speed={500} decal={'c-accent'}>Donate today! Donate today! Donate today! Donate today! Donate today! Donate today!Donate today! Donate today! Donate today!</ScrollTicker>
            </div>

            <section className={CSS.layout}>
                <div className={`${CSS.layoutHero}`}>
                    <div className={CSS.imageWrapper} style={{ aspectRatio: `840/717`}}>
                        <Image src={`/assets/img/charity/donate.jpg`} layout={`fill`}  alt="" />
                    </div>
                </div>

                <div className={`${CSS.container} formatted`}>
                    <p className="fs-0 fw-800 lh-1 c-primary pb-sm">Support by donating today</p>
                    <p>We hope you will join us in supporting Cesta Za Snem by donating individually today. Speakers, sponsors, and attendees are encouraged to contribute individually, and we will announce the cumulative funds raised for Cesta Za Snem toward the end of day two at IDEEA.</p>
                    <p>Please add “IDEEA” as a comment when you or your peers donate, enabling us to track your contribution as part of the IDEEA community.</p>
                    <p className="fs-3 fw-600 c-accent">For Donations:</p>
                    <p className="fw-600 c-primary">IBAN: CZ54 2700 0000 0011 1048 1110</p>
                    <p className="fw-600 c-primary">SWIFT: BACX CZ PP</p>
                    <p className="fw-600 c-primary">UniCredit Bank Czech Republic and Slovakia, a.s., <br/>Želetavská 1525/1, Praha 4, 140 92</p>
                <img className={CSS.donateIcon} src="/assets/img/charity/donate-icon.svg" alt="" />
                </div>

            </section>

            <div className="py-md">
                <ScrollTicker speed={500} decal={'c-accent'}>Donate today! Donate today! Donate today! Donate today! Donate today! Donate today!Donate today! Donate today! Donate today!</ScrollTicker>
            </div>


            {/* walk + run */}

            <section className={CSS.layout}>
                <div className={`${CSS.container} bg-primary p-lg formatted`}>
                    <p className={`fs-1 fw-400 caps lh-1`}>IDEEA Charity Walk&nbsp;&amp;&nbsp;Run</p>

                    <p className="fs-4 mt-sm">In addition to encouraging forum participants to donate individually, we will be organising the IDEEA Charity Run & Walk in the morning on day two of the conference. </p>
                    <p className="fs-4">For each participant, the bench will donate €10 on their behalf to Cesta za snem.</p>
                </div>

                <div className={`${CSS.layoutHero} grid-offset`}>
                    
                    <div className={CSS.imageWrapper} style={{ aspectRatio: `840/628`}}>
                        <Image src={`/assets/img/charity/charity-walk.jpg`} layout={`fill`}  alt="" />
                    </div>
                </div>
            </section>


            <Image src={`/assets/img/charity/group.jpg`} layout={`responsive`} width={1680} height={946} alt="" />


            <section className={CSS.layout}>
                <div className={`${CSS.layoutHero} grid-offset-negative`}>
                    <p className={`${CSS.container} bg-secondary fs-1 fw-400 caps lh-1`}>Subterra Open Weekend</p>
                    <div className={CSS.imageWrapper} style={{ aspectRatio: `840/588`}}>
                        <Image src={`/assets/img/charity/open-weekend.jpg`} layout={`fill`}  alt="" />
                    </div>
                </div>

                <div className={`${CSS.container} bg-primary p-lg formatted`}>
                    <p className="fs-5">We encourage all participants to partake in the Subterra Open Weekend, which is happening from the 22nd to the 24th of September, right after IDEEA Forum concludes.</p>
                    <p>3 days spent together in an environment where everyone is welcome. Everything is adapted so that families with children, disabled members or a group of friends can participate. Cesta za snem prepares a sports competition program where everyone can try various simple sports activities. The goal is to show everyone that having a disabled person in your midst is not an obstacle for trips or sports activities and that it is possible to live an active lifestyle. It is possible to live the way we like it, we just need to find new ways.</p>
                    <p>Subterra Open Weekend takes place on 22-24 September in Poslův Mlýn in Doksy and begins with arrival, accommodation, and division into teams on Friday. On Saturday, the participants try the prepared disciplines and the teams can choose their best representatives for the Sunday morning fights. The entire program ends with an announcement of results on Sunday after lunch.</p>

                    <p className='fw-600 mt-md'><Button href="https://www.cestazasnem.cz/openweekend.html" target={`_blank`} inverse>More info</Button></p>
                </div>
            </section>

        </>
    )
}